module.exports = __webpack_public_path__ + "img/easygds.5ede50a5.png";